import React, { useState, useEffect } from 'react';
import './styles/hero.css';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';

const Hero = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [images, setImages] = useState([
    '/media/hero/MBT-klodser.avif',
    '/media/hero/MBT-boger.avif',
    '/media/hero/FamilieB.avif'
  ]); // Standard billeder som fallback
  const [imagesData, setImagesData] = useState([]); // Tilføj ny state til komplet billeddata
  const [isLoading, setIsLoading] = useState(true);

  // Hent billeder fra Firestore
  useEffect(() => {
    const fetchHeroImages = async () => {
      try {
        const heroDocRef = doc(db, 'content', 'hero');
        const heroDoc = await getDoc(heroDocRef);
        
        if (heroDoc.exists() && heroDoc.data().images && heroDoc.data().images.length > 0) {
          const dbImagesData = heroDoc.data().images;
          const dbImages = dbImagesData.map(img => img.url);
          
          setImages(dbImages);
          setImagesData(dbImagesData);
        }
      } catch (error) {
        console.error('Fejl ved hentning af hero-billeder:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchHeroImages();
  }, []);

  const nextImage = () => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setCurrentImageIndex((prevIndex) => prevIndex + 1);
  };

  const previousImage = () => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setCurrentImageIndex((prevIndex) => prevIndex - 1);
  };

  // Automatisk skift hver 5 sekunder
  useEffect(() => {
    const timer = setInterval(nextImage, 5000);
    return () => clearInterval(timer);
  }, []);

  const handleTransitionEnd = () => {
    setIsTransitioning(false);
    if (currentImageIndex >= images.length) {
      setCurrentImageIndex(0);
    } else if (currentImageIndex < 0) {
      setCurrentImageIndex(images.length - 1);
    }
  };

  // Hjælpefunktion til at få focus-point CSS
  const getFocusPointStyle = (index) => {
    const imgData = imagesData[index % images.length];
    
    if (imgData && imgData.focusPoint) {
      // Konverter fokuspunktet til den korrekte CSS værdi
      return {
        '--focus-x': `${imgData.focusPoint.x}%`,
        '--focus-y': `${imgData.focusPoint.y}%`
      };
    }
    
    return {
      '--focus-x': '50%',
      '--focus-y': '50%'
    };
  };

  if (isLoading || images.length === 0) {
    return null; // Eller en loading indikator
  }

  return (
    <section className="hero">
      <div className="hero-slider">
        {images.map((image, index) => {
          const focusStyle = getFocusPointStyle(index);
          return (
            <div
              key={index}
              className={`hero-background ${index === currentImageIndex % images.length ? 'active' : ''}`}
              style={{ 
                transform: `translateX(${(index - (currentImageIndex % images.length)) * 100}%)`,
                ...focusStyle
              }}
              onTransitionEnd={handleTransitionEnd}
            >
              <div 
                className="hero-image" 
                style={{ 
                  backgroundImage: `url(${image})`,
                }}
              />
            </div>
          );
        })}
      </div>
      <button 
        className="hero-nav prev" 
        onClick={previousImage} 
        aria-label="Forrige billede"
        type="button"
      >
        &#10094;
      </button>
      <button 
        className="hero-nav next" 
        onClick={nextImage} 
        aria-label="Næste billede"
        type="button"
      >
        &#10095;
      </button>
      <div className="hero-dots">
        {images.map((_, index) => (
          <button
            key={index}
            className={`dot ${index === currentImageIndex % images.length ? 'active' : ''}`}
            onClick={() => {
              if (isTransitioning) return;
              setIsTransitioning(true);
              setCurrentImageIndex(index);
            }}
            aria-label={`Gå til billede ${index + 1}`}
            type="button"
          />
        ))}
      </div>
    </section>
  );
};

export default Hero;
